import $ from 'jquery';

// Scroll functionality for Tools Section on Providers Page
if ($('.horizontal-scroll-wrapper').length) {
  const btnLeft = $('.scroll-button-left');
  const scroller = $('.horizontal-scroll-wrapper');
  const items = $('.scroll-item').length;
  const containerWidth = scroller[0].scrollWidth;
  const scrollAmount = containerWidth / items;
  let curPosition = 0;
  let scrollTo;
  let savedPosition;
  btnLeft.css('opacity', 0);

  const updateCurPosition = (scrollTo) => {
    scroller.animate({ scrollLeft: scrollTo });
    savedPosition = scrollTo === 0 ? 0 : curPosition;
    curPosition =
      scrollTo >= containerWidth || scrollTo <= 0 ? savedPosition : scrollTo;
    btnLeft.css('opacity', curPosition !== 0 ? 1 : 0);
  };

  $('.scroll-button-right').on('click', function () {
    scrollTo = curPosition + scrollAmount;
    updateCurPosition(scrollTo);
  });

  $('.scroll-button-left').on('click', function () {
    scrollTo = curPosition - scrollAmount;
    updateCurPosition(scrollTo);
  });
}
